import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { rampCreateConnectionBodySchema } from "@common/schemas/domains/ramp/ramp-connection.schema";
import { FinancialConnectionDto } from "../dto/financialAccount/financial-connection.dto";

const c = initContract();

export const rampConnectionContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: rampCreateConnectionBodySchema,
            responses: {
                201: c.type<FinancialConnectionDto>(),
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/ramp-connection",
    },
);
